<template>
  <router-link :to="tagLink" class="project-tag-link" :title="`projects:${tagText}`">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: 'ProjectTagLink',
  props: {
    tagText: {
      type: String,
      required: true
    }
  },
  computed: {
    tagLink() {
      return {
        name: 'Projects',
        query: { tag: this.tagText }
      };
    }
  }
};
</script>

<style scoped>
.project-tag-link {
  text-decoration: none;
  color: #fff;
  background-color: #000;
  border: 2px solid red;
  padding: 5px 10px;
  border-radius: 15px;
  display: inline-block;
  margin: 5px;
}

.project-tag-link:hover {
  background-color: #222;
}
</style>
